/**
 * Build-target detection.
 *
 * The web app is the primary target. The Capacitor shell reuses the same bundle
 * but suppresses chrome that a native app should not repeat — the app already
 * has a name and an icon on the home screen, so the masthead is redundant there.
 */

/** True when running inside the Capacitor native shell. */
export function isNativeShell(): boolean {
  if (typeof window === 'undefined') return false;
  const cap = (window as any).Capacitor;
  return !!cap?.isNativePlatform?.();
}

/** True when the page is running as an installed PWA. */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (window.navigator as any).standalone === true
  );
}

/** Whether to draw the masthead (leaf mark + wordmark). Native shells skip it. */
export const showMasthead = (): boolean => !isNativeShell();

/** Coarse pointer — no hover, so the UI leans on press-and-hold instead. */
export function isCoarsePointer(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(pointer: coarse)').matches === true;
}
